<template>
    <div component="VoicesFooter" class="text-center">
        <!-- <v-pagination
            v-model="_page"
            :length="pageCount"
            :disabled="!pageCount"
            :total-visible="6"
            @input="paginate"
            circle
        ></v-pagination> -->
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'VoicesFooter',

    data() {
        return {
            limit: 20,
        };
    },

    methods: {
        ...mapMutations(['appendActorsFilters']),

        paginate() {
            this.$emit('paginate', { page: this.page, limit: this.limit });
        },
    },

    computed: {
        ...mapGetters(['getSelectedCharacter', 'getSearchIsVisible']),

        _page: {
            get() {
                return this.value;
            },
            set(page) {
                this.$emit('input', page);
            },
        },
    },

    watch: {
        'getSelectedCharacter.filter': {
            deep: true,
            handler() {
                this.page = 1;
                this.paginate();
            },
        },
        // getSearchIsVisible(val) {
        //     if (val) {
        //         this.page = 1;
        //         this.paginate();
        //     }
        // },
    },

    components: {},
};
</script>

<style lang="less">
@import '~@variables';

[component='VoicesFooter'] {
    .v-pagination__item,
    .v-pagination__navigation {
        width: 28px !important;
        min-width: 28px !important;
        height: 28px !important;
        min-height: 28px !important;
        font-size: 13px;

        .v-icon {
            color: @primary;
        }

        &.v-pagination__item--active {
            background-color: @primary !important;
        }

        &:before {
            width: 28px !important;
            min-width: 28px !important;
            height: 28px !important;
        }
    }
}
</style>
